import React from 'react'
import { Form, Input } from 'antd'
import { expressionFieldValidator, JsExpressionEditor } from 'components/JsExpressionEditor'
import { DirectionKey } from '../types'
import { getJsExpressionConfig } from './expressionConfig'

type ExpressionFieldProps = {
  /** Current MATCH direction — an OUTPUT rule reads our pet, so it hides the partner fields. */
  directionKey: DirectionKey
  /** Label for the description textarea (Color historically used "Expression description"). */
  descriptionLabel?: string
}

/**
 * MATCH-only: the JS expression that resolves the source side, plus an optional
 * human description. The editor exposes Adopets fields always, and the partner's
 * fields only for an INPUT rule (which reads the incoming external pet).
 */
export const ExpressionField = ({ directionKey, descriptionLabel = 'Description' }: ExpressionFieldProps) => (
  <Form.Item
    noStyle
    shouldUpdate={(prev, cur) =>
      prev.partner_key !== cur.partner_key || prev.direction_key !== cur.direction_key
    }
  >
    {({ getFieldValue }) => (
      <>
        <Form.Item
          label="Expression"
          name="expression"
          tooltip="JS expression evaluated to decide which mapping is used"
          rules={[
            { required: true, message: 'Missing an expression' },
            { validator: expressionFieldValidator },
          ]}
        >
          <JsExpressionEditor
            config={getJsExpressionConfig({
              fields: {
                ADOPETS: true,
                [getFieldValue('partner_key')]: directionKey !== 'OUTPUT',
              }
            })}
          />
        </Form.Item>

        <Form.Item label={descriptionLabel} name="description">
          <Input.TextArea
            autoSize={{ minRows: 1, maxRows: 4 }}
            placeholder="Optional description of the expression for humans"
          />
        </Form.Item>
      </>
    )}
  </Form.Item>
)
